<template lang="pug">
.tag(:class="{'tooltip': tooltip}")
  .livedot
  i.mdi(:class="[`mdi-${icon}`]", v-if="icon")
  span {{ text }}
  .tooltiptext(v-if="tooltip") {{ tooltip }}
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      required: false,
      default: '',
    },
    text: {
      type: String,
      required: true,
    },
    tooltip: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="sass" scoped>

@import '../variables.sass'

.tag
  align-items: center
  background-color: #cceaf6
  border-radius: 6px
  color: $primaryColor
  display: inline-flex
  font-size: 10px
  font-weight: 700
  line-height: 12px
  padding: 5px 7px 4px 6px
  text-transform: uppercase
  white-space: nowrap
  margin-bottom: 2px
  &.dot
    .livedot
      display: inline-block
  i
    font-size: 12px
    line-height: 12px
    margin-right: 3px
  & > *
    display: inline-block
  span
    max-width: 130px
    overflow: hidden
    text-overflow: ellipsis
  &.gray
    background-color: $lightGray
    color: rgb(79, 86, 107)
  &.green
    background-color: rgba(#27ae60, .25)
    color: #27ae60
  &.yellow
    background-color: #f9dfc8
    color: #e67e22
  &.red
    background-color: rgba(#c0392b, .25)
    color: #c0392b
  &.purple
    background-color: rgb(237, 235, 254)
    color: rgb(85, 33, 181)
  &.capitalize
    text-transform: capitalize
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Inter, "Helvetica Neue", Ubuntu, sans-serif
    font-weight: 500
    line-height: 16px
    padding: 2px 7px 2px 6px
    i
      line-height: 16px
  &.m-l-4
    margin-left: 4px
  .livedot
    border-radius: 100%
    background-color: red
    width: 6px
    height: 6px
    margin-right: 5px
    display: none
</style>
